import { connect } from 'react-redux'
import { string } from 'prop-types'
import React from 'react'
import { getFilterSearch } from '../../../selectors'
import { filterSearchWasChanged } from '../../../actions/filter'

class Searcher extends React.PureComponent {
  handleSearchChange = (event) => {
    this.props.filterSearchWasChanged(this.props.esKey, event.target.value)
  }
  handleKeyDown = (event) => {
    if (event.which === 27) {
      this.props.filterSearchWasChanged(this.props.esKey, '')
    }
  }
  render() {
    return (
      <div className="searcher">
        <input
          autoComplete="off"
          onChange={this.handleSearchChange}
          onKeyDown={this.handleKeyDown}
          placeholder={this.props.placeholder}
          type="text"
          value={this.props.search}
        />
      </div>
    )
  }
}
Searcher.propTypes = {
  esKey: string.isRequired,
  placeholder: string.isRequired,
  search: string.isRequired,
}

const mapStateToProps = (state, ownProps) => ({
  search: getFilterSearch(state, ownProps),
})

export default connect(mapStateToProps, {
  filterSearchWasChanged,
})(Searcher)
